module.exports = __webpack_public_path__ + "img/t2-c28.9bb02553.png";